const OWNER_ADDRESS = "EFrK7qyKG9bE3xxshadpfEwG46HzwTocELyuYLYAuQid"
const OWNER_PERCENTAGE = 0.2 // 20%
// const API_URL = "http://localhost:3000"
const API_URL = "https://api.solyfans.com"
const SOLANA_RPC_URL = "https://mainnet.helius-rpc.com/?api-key=e26bf879-6bb4-49c0-aafa-8e4d86687455"
export { API_URL, OWNER_ADDRESS, OWNER_PERCENTAGE, SOLANA_RPC_URL }